import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import { useSurfaceProps } from '../surfaces/util/SurfaceProvider'
import React, { FC, useMemo } from 'react'
import { GeckoComponentPolygon, GeckoPolygonalPlate } from 'types'

import { PolygonFeatureLabel3D } from './procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from './procedural/SurfaceMeshFeature3D'

export const PolygonalPlateFeature3D: FC<{ model: GeckoPolygonalPlate }> = ({
  model,
}) => {
  const { showPlateFeatureDebugColors } = useAssetVizInternal()
  const { bounds, wrapMode } = useSurfaceProps()

  const boundingPath = useMemo(
    () =>
      GeckoComponentPolygon.CreateFromPolygonalPlate(
        model.geometry,
        bounds,
        wrapMode
      ),
    [bounds, model.geometry, wrapMode]
  )

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        showDebugColors={showPlateFeatureDebugColors}
        userDataName={'plate'}
      />
      <PolygonFeatureLabel3D feature={model} polygonPath={boundingPath} />
    </group>
  )
}
